module.exports = __webpack_public_path__ + "img/001.3370b849.png";